import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});
export const figure3 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        backgroundColor:'rgba(255, 255, 255, 0.0)',
        marginTop: 50,
        height: 600,
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    colors: ['#4c5d6a', '#ed7d31'],
    exporting: {
        enabled: false
    },
    xAxis: [{
        categories: ['2005','2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018','2019','2020', '2021', '2022*'],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],
    yAxis: [{ // Primary yAxis
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        // lineColor: "#5b9bd5",
        // tickColor: "#5b9bd5",
        offset: 10,
        gridLineWidth: 0,
        max: 18,
        min: 0,
        tickInterval: 2,
        startOnTick: false,
        endOnTick: false,
        title: {
            text: 'Pourcentage',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }, { // Secondary yAxis
        title: {
            text: 'Millions',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        },
        max: 900,
        min: 0,
        tickInterval: 100,
        startOnTick: false,
        endOnTick: false,
        // plotLines: [{
        //     color: '#d7d7d7',
        //     width: 1,
        //     value: 1000
        // }],
        offset: 10,
        gridLineWidth: 0,
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
        //title: {
        //    text: 'Millions',
        //    style: {
        //        color: Highcharts.getOptions().colors[1]
        //    }
        //},
        opposite: true
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        // formatter: function() {
        //     console.log(this)
        // },
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                //enabled: false,
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [{
        name: 'Nombre de personnes sous-alimentées (Millions, ordonnée de droite)',
        id: "number",
        type: 'line',
        yAxis: 1,
        color: '#0d6bb6',
        
        zoneAxis: 'x',
        zones: [{
            value: 15
        }, {
            dashStyle: 'dot'
        }],

        dataLabels: {
            enabled: false,
	    formatter: function () {
			     return this.y.toString().replace('.', ',');
		     },
            style: {
                fontWeight: 'normal',
                color: '#999999',
                textOutline: false,
                fontSize: '12px'
            }

        },

        data: [
          { y: 793.4, dataLabels: {enabled:true} },
          746.5,
          691.0,
          663.1,
          661.8,
          { y: 597.8,dataLabels: {enabled:true} },
          578.3,
          580.0,
          572.3,
          { y: 563.9, dataLabels: {enabled:true} },
          { y: 588.9, dataLabels: {enabled:true} },
          586.4,
          571.8,
          586.8,
          { y: 612.8,dataLabels: {enabled:true} },
	       701.4,
	       738.9,
          {
            y: 735.1,
            dataLabels: {enabled:true},
            marker: {
                fillColor: '#ffffff',
                lineColor:'#0d6bb6',
                
                lineWidth: 2
            },
          }
        ],
        tooltip: {
            valueSuffix: ' Millions'
        }
        

    }, {
        name: 'Limite supérieure du nombre de personnes sous-alimentées',
        type: 'arearange',
        color: '#0d6bb6',
        lineWidth: 0,
        linkedTo: ':previous',
        fillOpacity: 0.3,
        zIndex: 0,
        yAxis: 1,
        
        zoneAxis: 'x',
        marker: {
            enabled: false
        },
        data: [
            {
                x: 14,
                low: 618.4,
                high: 618.4,
                name: "Point1",
            },
            {
                x: 15,
                low: 675.5,
                high: 765.2,
                name: "Point2",
                dataLabels: {
                    enabled:true, 
                    allowOverlap:true, 
                    className:'arearange-value',
                    padding:5,
                    // eslint-disable-next-line
                    enabled: true,
		    formatter: function () {
				    return this.y.toString().replace('.', ',');
			    },
                    style: {
                        fontWeight: 'normal',
                        textOutline: false,
                        color: '#999999',
                        fontSize: '12px'
                    }

                }
            },
            {
                x: 16,
                low: 701.9,
                high: 828.0,
                name: "Point1",
            },
        ],
        tooltip: {
            valueSuffix: ' Millions'
        },
        
    }, {
        name: 'Prévalence de la sous-alimentation (pourcentage, ordonnée de gauche)',
        id: "prev",
        type: 'line',
        color: '#ed7d31',
        
        zoneAxis: 'x',
        zones: [{
            value: 15
        }, {
            dashStyle: 'dot'
        }],
        dataLabels: {
            enabled: false,
	    formatter: function () {
			     return this.y.toString().replace('.', ',');
		     },
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }
        },
        data: [
          { y: 12.1, dataLabels: {enabled:true} },
          11.2, 
          10.3, 
          9.7, 
          9.6,
          { y:8.6, dataLabels: {enabled:true} },
          8.2,
          8.1,
          7.9,
          { y: 7.7, dataLabels: {enabled:true} },
          { y: 7.9, dataLabels: {enabled:true} },
          7.8,
          7.5,
          7.6,
          { y:7.9, dataLabels: {enabled:true} },
          { y: 8.9, dataLabels: {enabled:true} },
            {
	      y: 9.3,
	      y: 9.2,				  
              dataLabels: {
                  enabled:true, 
                //   x: 200, 
                //   y: -10
                },
              marker: {
                  fillColor: '#ffffff',
                  lineColor:'#ed7d31',
                  lineWidth: 2
                 
              },

          }
        ],
        tooltip: {
            valueSuffix: '%'
        }
    }, {
        name: 'Gamme de prévalence de la sous-alimentation',
        type: 'arearange',
        color: '#ed7d31',
        lineWidth: 0,
        linkedTo: ':previous',
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
            enabled: false
        },
        data: [
            {
                x: 14,
                low: 8.0,
                high: 8.0,
                name: "Point1",
            },
            {
                x: 15,
                low: 8.7,
                high: 9.8,
                name: "Point2",
                dataLabels: {
                    enabled:true, 
                    allowOverlap:true, 
                    className:'arearange-value',
                    padding:5,
                    // verticalAlign:top
                    // useHTML:true
                    formatter: function () {
                        return this.y+"%";
                    },
                    style: {
                        fontWeight: 'normal',
                        textOutline: false,
                        color: '#999999',
                        fontSize: '12px'
                    }

                }
            },
            {
                x: 16,
                low: 8.9,
                high: 10.5,
                name: "Point1",
            },
        ],
        tooltip: {
            valueSuffix: '%'
        },
        
    }],


}
